<template>
	<div class="order_status_dialog_goods" v-if="order_goods">
		<!-- 表格 -->
		<el-table :data="order_goods" height="500" tooltip-effect="dark">
			<!-- 商品名称 -->
			<el-table-column :label="$t('message.costatus.table8')" width="300" align="center" show-overflow-tooltip>
				<template v-slot="{row}">
					<div class="order_status_dialog_goods_box">
						<!-- 图片 -->
						<router-link :to="{name: 'pdetail', query:{id: row.goods_id}}"
							class="order_status_dialog_goods_img">
							<img :src="row.goods_images[0]" alt="">
						</router-link>
						<!-- 商品标题 -->
						<router-link :to="{name: 'pdetail', query:{id: row.goods_id}}"
							class="order_status_dialog_goods_title">
							<span>{{row.goods_name}}</span>
						</router-link>
					</div>
				</template>
			</el-table-column>
			<!-- 单价 -->
			<el-table-column :label="$t('message.costatus.table9')" align="center" width="160" v-if="powerPrice">
				<template v-slot="{row}">
					<span>{{currency}}</span>
					<span class="order_status_dialog_goods_price">{{row.unit_price}}</span>
				</template>
			</el-table-column>
			<!-- 規格 -->
			<el-table-column label="規格" align="center" v-if="powerPrice">
				<template v-slot="{row}">
					<span class="order_status_dialog_goods_price">{{row.attr_value}}</span>
			 </template>
			</el-table-column>
			<!-- 数量 -->
			<el-table-column :label="$t('message.costatus.table10')" align="center" width="120">
				<!-- :min="1" -->
				<template v-slot="{row}">
					<el-input-number v-if="row.goodnumber" :value="row.goods_number" size="mini" :min="1"
						:max="row.goodnumber" @change="handleChange($event, row)" class="order_status_dialog_goods_num"
						:disabled="![1,2,3].includes(examine)">
					</el-input-number>
					<el-input-number v-else :value="row.goods_number" size="mini" :min="1"
						@change="handleChange($event, row)" class="order_status_dialog_goods_num"
						:disabled="![1,2,3].includes(examine)">
					</el-input-number>
				</template>
			</el-table-column>
			<!-- 备注 -->
			<!--    <el-table-column
                :label="$t('message.costatus.table11')"
                align="center">
                <template v-slot="{row}">
                    <el-input
                        size="mini"
                        v-model="row.remark"
                        :disabled="![1,2,3].includes(examine)">
                    </el-input>
                </template>
            </el-table-column> -->
			<!-- 单位 -->
			<el-table-column :label="$t('message.costatus.table12')" prop="unit" align="center" width="70">
			</el-table-column>
			<!-- 合计 -->
			<el-table-column :label="$t('message.costatus.table13')" align="center" width="160" v-if="powerPrice">
				<template v-slot="{row}">
					<span>{{currency}}</span>
					<span class="order_status_dialog_goods_price">
						{{row.goods_price}}
					</span>
				</template>
			</el-table-column>
			<!-- 操作 -->
			<el-table-column :label="$t('message.costatus.table14')" align="center" v-if="[1,2,3].includes(examine)">
				<template v-slot="{row}">
					<div>
						<!-- 修改按钮 -->
						<!--   <el-button
                            type="text"
                            @click="handleChange('',row)">
                            {{$t("message.costatus.submitBtn1")}}
                        </el-button> -->
						<!-- 删除按钮 -->
						<el-button type="text" @click="handleDelGoods(row.rec_id)">
							{{$t("public.delBtn")}}
						</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!-- 退货 & 合计 -->
		<div class="order_status_dialog_goods_end clearfix">
			<!-- 合计 & 提交 -->
			<div class="order_status_dialog_goods_total">
				<!-- 数量合计 -->
				<div>
					<span>{{$t("message.costatus.total1")}}</span>
					<span class="order_status_dialog_goods_total_count">{{totalMsg.totalCount}}</span>
					<span>{{$t("message.costatus.total2")}}</span>
				</div>
				<!-- 价格合计 -->
				<div v-if="powerPrice">
					<span>{{$t("message.costatus.total3")}}</span>
					<span>{{currency}}</span>
					<span class="order_status_dialog_goods_total_price">{{totalMsg.totalPrcie}}</span>
				</div>
				<!-- 折后价格 -->
				<div v-if="powerPrice">
					<span>{{$t("message.costatus.total4")}}</span>
					<span>{{currency}}</span>
					<span class="order_status_dialog_goods_total_price">{{order_detail.order_amount}}</span>
				</div>
				<!-- 审批流程提交按钮 -->
				<el-button type="primary" @click="submitExamine" v-if="examine > 0">
					<span v-if="[1,3].includes(examine)">{{$t("message.costatus.submitBtn2")}}</span>
					<span v-if="examine == 2">{{$t("message.costatus.submitBtn3")}}</span>
					<span v-if="examine == 4">{{$t("message.costatus.submitBtn4")}}</span>
				</el-button>
				<!-- 删除订单按钮 -->
				<el-button type="danger" v-if="examine == 2" @click="handleDel">
					<span>删除订单</span>
				</el-button>
			</div>
			<!-- 退换货 -->
			<!-- v-if="return_status.includes(order_detail.order_status) && order_detail.complete_status!==0 && examine != -1" -->
			<div class="order_status_dialog_goods_return">
				<!-- 文本输入 -->
				<div class="order_status_return_goods_text" v-if="power.includes(0) || power.includes(21)">
					<!-- 文本输入 -->
					<span>{{$t("message.costatus.return1")}}</span>
					<el-input type="textarea" :rows="2" v-model="textarea">
					</el-input>
				</div>
				<!-- 申请退货按钮 -->
				<el-button type="primary" @click="returnGoods"
					v-if="power.includes(0) || power.includes(21)">
					{{$t("message.costatus.return2")}}
				</el-button>
				<!-- 申请取消按钮 -->
				<el-button type="primary" @click="cancelGoods"
					v-if="power.includes(0) || power.includes(111) || power.includes(9)">
					{{$t("message.costatus.return3")}}
				</el-button>
				<!-- 加入購物車按钮 -->
				<el-button type="primary" @click="handleAdd"
					v-if="power.includes(0) || power.includes(111) || power.includes(23)">
					{{$t("message.costatus.return4")}}
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from 'vuex'

	export default {
		data() {
			return {
				return_status: ['0', '1', '2', '3', '4', '5'], // 可退货状态
				textarea: "", // 退货说明文本
			}
		},
		props: ["remark", "status"],
		computed: {
			...mapState({
				order_goods: state => state.order.order_goods,
				order_goodsr: state => state.order.order_goodsr,
				order_detail: state => state.order.order_detail,
				examine: state => state.order.examine, // 审核状态
				power: state => state.user.power, // 用户权限
				currency: state => state.currency
			}),
			...mapGetters([
				'powerPrice',
			]),
			totalMsg() {
				// console.log(this.order_goods,this.order_goodsr)
				let totalCount = 0,
					totalPrcie = 0;
				for (let item of this.order_goods) {
					totalCount += Number(item.goods_number);
					totalPrcie += Number(item.goods_price);
				}
				return {
					totalCount,
					totalPrcie: totalPrcie.toFixed(2)
				}
			}
		},
		methods: {
			...mapActions([
				"addOrderShoppingCart",
				"getOrderStatusList",
				"changeOrderStatusGoods",
				"delOrderStatusGoods",
				"handleOrderCancel",
				"handleReturn",
				"handleAuditor", // 审核员
				"handleLower", // 打单员
				"handleDelOrder"
			]),
			handleAdd() { // 加入购物车按钮
				// console.log(this.order_goods)
				this.addOrderShoppingCart(this.order_goodsr).then((res) => {
					if (res.type) {
						this.$message({
							showClose: true,
							message: this.$t("message.cqorder.succmsg1"),
							type: "success"
						})

					} else {
						this.$message({
							showClose: true,
							message: this.$t('message.cart.errmsg5'),
							type: "warning"
						})
					}
				})
			},
			handleChange(val, data) { // 修改商品
				let {
					rec_id,
					goods_number,
					remark,
					order_id
				} = data;
				if (!!val) {
					goods_number = val;
				}
				this.changeOrderStatusGoods({
					rec_id,
					goods_number,
					remark,
					id: order_id
				}).then((res) => {
					if (res) {
						this.$message({
							showClose: true,
							message: this.$t("public.modifySucc"),
							type: "success"
						})
					}
				})
			},
			handleDelGoods(rec_id) { // 删除商品
				this.delOrderStatusGoods(rec_id).then((res) => {
					if (res) {
						this.$message({
							showClose: true,
							message: this.$t("public.delSucc"),
							type: "success"
						})
					}
				})
			},
			returnGoods() { // 退货请求
				let order_id = this.order_detail.order_id,
					pay_note = this.textarea;
				this.handleReturn({
					order_id,
					pay_note,
				}).then((res) => {
					if (res) {
						this.$message({
							showClose: true,
							message: this.$t("message.costatus.succmsg1"),
							type: "success"
						})
						this.textarea = "";
					}
				})
			},
			cancelGoods() { // 订单取消请求
				let order_id = this.order_detail.order_id,
					cancel_note = this.textarea;
				this.handleOrderCancel({
					order_id,
					cancel_note,
				}).then((res) => {
					if (res.type) {
						this.$message({
							showClose: true,
							message: this.$t("message.costatus.succmsg1"),
							type: "success"
						})
						this.textarea = "";
					}
				})
			},
			submitExamine() { // 审核状态提交
				let order_id = this.order_detail.order_id,
					remark = this.remark,
					status = this.status;
				if ([1, 3].includes(this.examine)) {
					this.handleAuditor({
						order_id,
						remark,
						status
					}).then((res) => {
						if (res) {
							this.$message({
								showClose: true,
								message: this.$t("public.modifySucc"),
								type: "success"
							})
						}
					})
				} else {
					if (this.examine === 4 && !this.power.includes(10)) {
						this.$message({
							showClose: true,
							message: this.$t("message.costatus.errmsg2"),
							type: "error"
						})
						return;
					}
					this.handleLower({
						order_id,
						remark
					}).then((res) => {
						if (res) {
							this.$message({
								showClose: true,
								message: this.$t("message.costatus.succmsg2"),
								type: "success"
							})
						}
					})
				}
			},
			handleDel() {
				this.$confirm(this.$t("message.costatus.warnmsg1"), {
					confirmButtonText: this.$t("public.confirmBtn"),
					cancelButtonText: this.$t("public.cancelBtn"),
					type: "warning"
				}).then(() => {
					this.handleDelOrder().then((res) => {
						if (res.type) {
							this.$message({
								showClose: true,
								message: this.$t("public.delSucc"),
								type: "success"
							})
							let order_sn = sessionStorage.getItem("order_sn") || "",
								release = sessionStorage.getItem("release") || "",
								relend = sessionStorage.getItem("relend") || "",
								department = sessionStorage.getItem("department") || "",
								member = sessionStorage.getItem("member") || "";
							this.getOrderStatusList({
								order_sn,
								release,
								relend,
								department,
								member
							})
						}
					})
				}).catch(() => {})
			}
		},
		created() {
			this.textarea = "";
		},
	}
</script>

<style scoped>
	/* 滚动条 */
	/deep/ .el-table__body-wrapper::-webkit-scrollbar {
		width: 5px;
		height: 10px !important;
		background-color: #ddd;

	}

	.order_status_table>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
		background-color: #fd641f;
		border-radius: 5px;
	}

	.order_status_dialog_goods_box {
		text-align: left;
	}

	/* 商品图片 */
	.order_status_dialog_goods_img {
		position: relative;
		display: inline-block;
		vertical-align: middle;
		width: 60px;
		height: 60px;
	}

	.order_status_dialog_goods_img>img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-width: 100%;
		max-height: 100%;
	}

	/* 商品标题 */
	.order_status_dialog_goods_title {
		color: #606266
	}

	.order_status_dialog_goods_title:hover {
		color: #ff6700;
	}

	/* 价格 */
	.order_status_dialog_goods_price {
		margin-left: 5px;
		color: #ff6700;
	}

	/* 计数器 */
	.order_status_dialog_goods_num {
		width: 100%;
	}

	/* 结尾部分 */
	.order_status_dialog_goods_end {
		margin-top: 10px;
	}

	/* 退货申请区域 */
	.order_status_dialog_goods_return {
		width: 400px;
	}

	/* 文本输入区域 */
	.order_status_return_goods_text {
		margin-bottom: 10px;
	}

	/* 合计区域 */
	.order_status_dialog_goods_total {
		float: right;
		text-align: right;
	}

	.order_status_dialog_goods_total>div {
		margin-bottom: 5px;
	}

	/* 数量统计 */
	.order_status_dialog_goods_total_count {
		color: #ff6700;
	}

	/* 合计价格 */
	.order_status_dialog_goods_total_price {
		font-size: 16px;
		font-weight: bold;
		color: #ff6700;
	}

	.order_status_dialog_goods_total>div>span+span {
		margin-left: 5px;
	}

	/* 滚动条 */
	.order_status_dialog_goods>>>.el-table__body-wrapper::-webkit-scrollbar {
		width: 5px;
		height: 5px;
		background-color: #ddd;
	}

	.order_status_dialog_goods>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
		height: 10px;
		border-radius: 5px;
	}
</style>
